import unpackAction from "./functions/unpackAction";

export type { UnpackedAction } from "./functions/unpackAction";

const historyTimelineRepository = {
  unpackAction,
};

export default historyTimelineRepository;
